const Admin = () => import('./AdminPage.vue');

const routes = [
  {
    path: '/admin',
    name: 'admin',
    id: 'admin',
    component: Admin,
    omitFromNav: true,
  },
];

export default routes;
